export class DropdownValue {
  constructor(public label: string, public value: any) {}
}
